import { useSelector } from "react-redux"

export const IndirectEval = (evalString) =>{
    // const selectedData = useSelector((state)=>state.formData.selectedData)
        return eval(evalString)
}

